/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card-container[_ngcontent-%COMP%]{display:flex;padding:0 20px 20px 0}.card-container[_ngcontent-%COMP%]   mat-card[_ngcontent-%COMP%]{width:100%}.mat-card-header-actions[_ngcontent-%COMP%]{display:flex;margin-top:-5px}.mat-card-title[_ngcontent-%COMP%]{font-size:20px}ui-login-attempts-grid[_ngcontent-%COMP%]{top:-15px;position:relative}"];
export { styles as styles };
